export const DEPLOY_ENV = import.meta.env.VITE_DEPLOY_ENV ?? "local";
export const SENTRY_DSN = import.meta.env.VITE_SENTRY_DSN;
